import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@capacit-com/lara-law-shared-ui";
import PageContent from "./PageContent";

const PageNotFoundView = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get the route from the pathname
  const route = location.pathname.split("/404/")[1];
  const content = {
    workspace: {
      title: "Workspace ikke fundet",
      description: "Beklager, vi kunne ikke finde det valgte workspace.",
      buttonText: "Gå tilbage",
    },
    "workspace/file-not-found": {
      title: "Workspace dokument ikke fundet",
      description: "Beklager, vi kunne ikke finde det valgte dokument.",
      buttonText: "Gå tilbage",
    },
    "workspace/file-not-found/dashboard": {
      title: "Workspace dokument ikke fundet",
      description: "Beklager, vi kunne ikke finde det valgte dokument.",
      buttonText: "Gå tilbage",
    },
    legislation: {
      title: "Kilden blev ikke fundet",
      description: "Beklager, vi kunne ikke finde den valgte kilde.",
      buttonText: "Gå tilbage",
    },
    "legislation/file-not-found": {
      title: "Kildedokumentet blev ikke fundet",
      description: "Beklager, vi kunne ikke finde det valgte dokument.",
      buttonText: "Gå tilbage",
    },
    "chat/file-not-found": {
      title: "Dokumentet blev ikke fundet",
      description: "Beklager, vi kunne ikke finde det valgte dokument.",
      buttonText: "Gå tilbage",
    },
    "overview-not-found": {
      title: "Samtalen blev ikke fundet",
      description: "Beklager, vi kunne ikke finde samtalen, du leder efter.",
      buttonText: "Gå tilbage",
    },
    default: {
      title: "Side ikke fundet",
      description: "Beklager, vi kunne ikke finde siden, du leder efter.",
      buttonText: "Gå tilbage",
    },
  };

  const getContent = () => {
    if (!route) return content.default;
    return content[route as keyof typeof content] || content.default;
  };

  const { title, description, buttonText } = getContent();

  return (
    <PageContent title="404 - Side ikke fundet" appSidebar={true}>
      <div className="flex items-center justify-center flex-col h-full">
        <p className="text-base font-semibold text-primary">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">
          {title}
        </h1>
        <p className="mt-6 text-base leading-7">{description}</p>
        <div className="w-fit mt-4">
          <Button
            onClick={() => {
              navigate(-1);
            }}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </PageContent>
  );
};

export default PageNotFoundView;
